import React from "react";

export const CabinetPlanificationsAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: "/cabinet/planifications",
      component: React.lazy(() => import("./CabinetPlanificationsApp")),
    },
  ],
};
